import React from 'react';
import { Collection } from '../types';

interface CategorySidebarProps {
  collections: Collection[];
  selected: string | null;
  onSelect: (handle: string | null) => void;
  showAll?: boolean;
}

export function CategorySidebar({ collections, selected, onSelect, showAll = true }: CategorySidebarProps) {
  if (collections.length <= 1 && !showAll) {
    return null;
  }

  return (
    <aside className="category-sidebar">
      <h3 className="sidebar-title">Categories</h3>
      <ul className="category-list">
        {showAll && collections.length > 1 && (
          <li>
            <button
              className={`category-item ${selected === null ? 'active' : ''}`}
              onClick={() => onSelect(null)}
            >
              <span className="category-radio">
                {selected === null ? '●' : '○'}
              </span>
              All Products
            </button>
          </li>
        )}
        {collections.map((collection) => (
          <li key={collection.handle}>
            <button
              className={`category-item ${selected === collection.handle ? 'active' : ''}`}
              onClick={() => onSelect(collection.handle)}
            >
              <span className="category-radio">
                {selected === collection.handle ? '●' : '○'}
              </span>
              {collection.title}
              {collection.productCount !== undefined && (
                <span className="category-count">({collection.productCount})</span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default CategorySidebar;
